import { GET_MISSIONS_LIST, GET_MISSIONS_SEARCH } from './constants'
import MissionsListService from '../MissionsListService'


export const getMissionsListAction = (params) => async (dispatch) => {
  const missionsList = await MissionsListService.getMissionsList(params)
  dispatch({
    type: GET_MISSIONS_LIST,
    payload: missionsList,
  })
}
export const getMissionsSearchAction = (params) => async (dispatch) => {
  const missionsSearch = await MissionsListService.getMissionsSearch(params)
  dispatch({
    type: GET_MISSIONS_SEARCH,
    payload: missionsSearch,
  })
}
